
/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * Copyright IBM Corp. 2017, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'react-dom',
	'../views/UserInfoCell',
	'../../nls/StringResources',
	'bi/glass/app/plugins/MenuActionInterface',
	'caglass/caglass.webpack.bundle',
	'jquery'
], function(React, ReactDOM, UserInfoCell, StringResources, MenuActionInterface, CAGlassBundle, $) {
	'use strict';

	const ActionHandlers = {

		login(context) {
			return CAGlassBundle.secondaryLogin(context.glassContext).catch(function(error) {
				context.glassContext.getCoreSvc('.Logger').error('Secondary login failed', error);
			});
		},

		logout(context) {
			const appController = context.glassContext.appController;
			appController.trigger('application:logout');
			return appController.close(false, false).then(function() {
				const killLogSession = function(glassContext) {
					return glassContext.getCoreSvc('.UserProfile').disableLoggingSession();
				};
				const killDcoCookie = function(glassContext) {
					return glassContext.getCoreSvc('.DigitalContext').killDcoCookie();
				};
				const resetAnalyticsCookie = function (glassContext) {
					return glassContext.getCoreSvc('.Instrumentation').resetAnalyticsCookie();
				};
				return context.glassContext.getSvc('.Logout').then(function(logoutSvc) {
					logoutSvc.registerPreLogout(killLogSession);
					logoutSvc.registerPreLogout(killDcoCookie);
					if (context.glassContext.getCoreSvc('.Instrumentation').enabled) {
						logoutSvc.registerPreLogout(resetAnalyticsCookie);
					}
					return logoutSvc.logOut(context);
				});
			});
		},

		accountSettings(context) {
			const myPreferencesId = 'actions.openMyPreferences';
			if (context.glassContext.appController.canExecuteAction(myPreferencesId, context)) {
				return context.glassContext.appController.performAction(myPreferencesId, context);
			}
		},

		about(context) {
			const actionId = 'actions.openCognosAnalyticsAboutBox';
			if (context.glassContext.appController.canExecuteAction(actionId, context)) {
				context.glassContext.appController.performAction(actionId, context);
			}
		}
	};

	class MyMenuController extends MenuActionInterface {

		/**
		 * Called when the menu item is selected.
		 */
		onSelectItem(context) {
			const key = this._getPluginKey(context.target.itemId);
			const handler = ActionHandlers[key];
			if (handler) {
				const handle = handler.bind(this,context);
				return handle();
			}
		}

		_renderAccountSettings(context) {
			const account = context.glassContext.profile.account;
			if (account) {
				context.target.activeObject.empty();
				const $el = context.target.activeObject;
				const $container = $('<div class="com.ibm.bi.glass.caPersonalMenu.accountSettings"/>');
				$container.appendTo($el);
				const { displayName, email, tenantName } = this._getUserInfoProps(account);
				ReactDOM.render(
					<UserInfoCell
						displayName={displayName}
						email={email}
						tenantName={tenantName}
						linkText={StringResources.get('profileAndSettings')}
						linkAction={this.onSelectItem.bind(this, context)}
					/>,
					$container[0]);
			}
		}

		onRenderItem(context) {
			const key = this._getPluginKey(context.target.itemId);
			switch ( key ) {
				case 'accountSettings':
					return this._renderAccountSettings(context);
				case 'login':
				case 'logout':
					return context.target.activeObject.addClass('link');
				default: break;
			}
		}

		_getUserInfoProps(account) {
			const displayedInfo = {
				displayName: account.displayName
			};
			if (account.email) {
				displayedInfo.email = account.email;
			}
			if (account.tenantName) {
				displayedInfo.tenantName = `(${account.tenantName})`;
			}
			return displayedInfo;
		}

		onRender() {
		}

		isItemVisible(context) {
			const itemId = context.target.itemId;
			const { account } = context.glassContext.profile;
			switch ( itemId ) {
				case 'com.ibm.bi.glass.common.login':
				case 'login.divider':
					return account.showLogIn;
				case 'com.ibm.bi.glass.common.logout':
				case 'logout.divider':
					return !account.isAnonymous;
				default:
					return true;
			}
		}

		_getPluginKey(itemId) {
			const idTokens = itemId.split('.');
			return idTokens[idTokens.length - 1];
		}

	}

	return MyMenuController;
});
